import Vue from 'vue';

const PLUGIN_GLOBAL_KEY = 'RemoteMonitoringAdminService';
const PLUGIN_SCRIPT_NAME = 'remote-monitoring-plugin.js';
const PLUGIN_STYLE_NAME = 'style.css';

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    if (typeof document === 'undefined') {
      reject(new Error('Document is not available'));
      return;
    }

    if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => resolve();
    script.onerror = (error) => reject(error);
    document.head.appendChild(script);
  });

const ensureStyle = (href) => {
  if (typeof document === 'undefined') {
    return;
  }

  if (document.querySelector(`link[href="${href}"]`)) {
    return;
  }

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = href;
  link.dataset.remoteMonitoringStyle = 'true';
  document.head.appendChild(link);
};

const ensureGlobalVue = () => {
  if (typeof window !== 'undefined' && !window.Vue) {
    window.Vue = Vue;
  }
};

const normalizeBaseUrl = (baseUrl) => {
  if (!baseUrl) {
    return '';
  }

  return baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
};

const toBoolean = (value) => `${value}` === 'true';

export async function initRemoteMonitoring({
  axiosClient,
  config,
  notificationService,
  sipService
}) {
  const axiosInstance = axiosClient?.instance || axiosClient;
  const appConfig = config || {};

  if (!axiosInstance) {
    // eslint-disable-next-line no-console
    console.error(
      'Не удалось загрузить RemoteMonitoringDoctorService - отсутствует axios-клиент'
    );
    return;
  }

  const apiClient = {
    client: axiosInstance,
    options: {
      baseUrl: appConfig.APP_HOST
    }
  };

  const isUseLocalAssets = toBoolean(
    appConfig?.APP_USE_LOCAL_REMOTE_MONITORING_SERVICE
  );
  const serviceRootUrl = normalizeBaseUrl(
    appConfig?.APP_REMOTE_MONITORING_SERVICE_URL
  );

  if (!isUseLocalAssets && !serviceRootUrl) {
    // eslint-disable-next-line no-console
    console.error(
      'Не удалось загрузить RemoteMonitoringDoctorService - не указан URL сервиса'
    );
    return;
  }

  const pluginScriptUrl = isUseLocalAssets
    ? appConfig?.APP_REMOTE_MONITORING_SERVICE_LOCAL_URL
    : `${serviceRootUrl}${PLUGIN_SCRIPT_NAME}`;
  const pluginStyleUrl = isUseLocalAssets
    ? appConfig?.APP_REMOTE_MONITORING_SERVICE_CSS_LOCAL_URL
    : `${serviceRootUrl}${PLUGIN_STYLE_NAME}`;

  if (!pluginScriptUrl || !pluginStyleUrl) {
    // eslint-disable-next-line no-console
    console.error(
      'Не удалось загрузить RemoteMonitoringDoctorService - не указаны пути до assets'
    );
    return;
  }

  ensureGlobalVue();
  ensureStyle(pluginStyleUrl);

  if (!window[PLUGIN_GLOBAL_KEY]) {
    try {
      await loadScript(pluginScriptUrl);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        'Не удалось загрузить RemoteMonitoringDoctorService',
        error
      );
      return;
    }
  }

  const remoteMonitoringPlugin = window[PLUGIN_GLOBAL_KEY];

  console.log('remoteMonitoringPlugin', remoteMonitoringPlugin);

  if (!remoteMonitoringPlugin || !remoteMonitoringPlugin.install) {
    // eslint-disable-next-line no-console
    console.error('Не удалось инициализировать RemoteMonitoringDoctorService');
    return;
  }

  // Vue.use(remoteMonitoringPlugin, {
  //   apiClient,
  //   locale: 'ru',
  //   settings: appConfig.APP_SETTINGS || 'gostelemed',
  //   uiService,
  //   sipService: sipService || Vue.prototype.$sipService,
  // });

  Vue.use(remoteMonitoringPlugin, {
    apiClient,
    settings: appConfig?.APP_SETTINGS || 'gostelemed',
    notificationService: notificationService || Vue.prototype.$notificationService,
    sipService: sipService || Vue.prototype.$sipService,
  });
}

export default initRemoteMonitoring;
